export class MockTopBarService {
  getItems = jasmine.createSpy('getItems');
  getItemCounters = jasmine.createSpy('getItemCounters');
}
